import { createFileRoute, useParams } from "@tanstack/react-router";
import { LeadDetailPage } from "@/components/crm/LeadDetailPage";

export const Route = createFileRoute("/user/_layout/crm/leads_/$id")({
  component: UserLeadDetail,
});

function UserLeadDetail() {
  const { id } = useParams({ from: "/user/_layout/crm/leads_/$id" });
  return <LeadDetailPage leadId={id} role="user" />;
}
